import { Component, Input } from '@angular/core';
import { CommunicationService } from 'app/_services/communication.service';
import { ISettings } from 'app/_models/ISettings';
import { IconDefinition, faXmark } from '@fortawesome/free-solid-svg-icons';
import { AppComponent } from 'app/app.component';

@Component({
  selector: 'dialog-header',
  templateUrl: './dialog-header.component.html',
  styleUrls: ['./dialog-header.component.css']
})
export class DialogHeaderComponent {
  @Input() icon: IconDefinition;
  @Input() title: string;  
  @Input() settings: ISettings;
  hardRefresh: boolean = false;
  closeEnabled: boolean = true;
  faXmark: IconDefinition = faXmark;  

  constructor(
    public app: AppComponent,
    private communicationService: CommunicationService
  ) { }

  close(): void { 
    if (!this.closeEnabled) {
      this.app.alertError(this.app.translations.ALERT_Error_CloseWithoutSave);
      return;
    }

    if (this.hardRefresh) {
      window.location.href = '/base';
      return;
    }

    this.communicationService.closeDialog(); 
  }
}